import React from "react";
import {
    Box,
    Container,
    Grid,
    Typography,
    Card,
    CardMedia,
    CardContent,
    Avatar,
    Stack,
    useTheme,
    Paper,
} from "@mui/material";

// Ícones para ilustrar os valores (MUI Icons)
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";

// Importação da imagem original
import Equipe from "../assets/equipe.jpg";

export default function Sobre() {
    const theme = useTheme();

    const cardsData = [
        {
            icon: <StarOutlineIcon fontSize="large" />,
            title: "Excelência",
            text: "Perfeição nos detalhes, da curadoria à entrega."
        },
        {
            icon: <VerifiedUserOutlinedIcon fontSize="large" />,
            title: "Transparência",
            text: "Relações claras. Segurança total na sua compra."
        },
        {
            icon: <FavoriteBorderOutlinedIcon fontSize="large" />,
            title: "Cliente no Centro",
            text: "Sua satisfação guia nossa evolução constante."
        }
    ];

    return (
        <Box sx={{ bgcolor: "#ffffff", overflowX: "hidden" }}>
            {/* --- HERO SECTION --- */}
            <Box
                sx={{
                    bgcolor: "primary.main", // Usa a cor primária do seu tema
                    color: "white",
                    py: { xs: 8, md: 12 },
                    borderRadius: { xs: "0 0 20px 20px", md: "0 0 60px 60px" },
                    textAlign: "center",
                    boxShadow: 3,
                    mb: 8,
                }}
            >
                <Container maxWidth="md">
                    <Typography
                        variant="h3"
                        component="h1"
                        sx={{ fontWeight: 800, mb: 2, letterSpacing: "-0.03em" }}
                    >
                        Sobre Nós
                    </Typography>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 400,
                            opacity: 0.9,
                            maxWidth: 600,
                            mx: "auto",
                            lineHeight: 1.6,
                        }}
                    >
                        Conheça um pouco mais sobre a nossa história, propósito e o que nos
                        move todos os dias.
                    </Typography>
                </Container>
            </Box>

            <Container maxWidth="lg" sx={{ mb: 10 }}>
                {/* --- SEÇÃO PRINCIPAL (TEXTO + IMAGEM) --- */}
                <Grid container spacing={8} alignItems="center">

                    <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
                        <Box
                            sx={{
                                position: "relative",
                                "&::before": {
                                    content: '""',
                                    position: "absolute",
                                    top: -20,
                                    right: -20,
                                    width: "100%",
                                    height: "100%",
                                    border: `2px solid ${theme.palette.primary.light}`,
                                    borderRadius: 4,
                                    zIndex: 0,
                                    display: { xs: "none", md: "block" },
                                    
                                },
                            }}
                        >
                            <Card
                                elevation={6}
                                sx={{
                                    borderRadius: 4,
                                    position: "relative",
                                    zIndex: 1,
                                    transition: "transform 0.3s",
                                    "&:hover": { transform: "scale(1.01)" },
                                    
                                }}
                            >
                                <CardMedia
                                    component="img"
                                    height="450"
                                    image={Equipe}
                                    alt="Nossa equipe trabalhando"
                                    sx={{ objectFit: "cover" }}
                                />
                            </Card>
                        </Box>
                    </Grid>

                    {/* Coluna do Texto */}
                    <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
                        <Box>
                            <Typography
                                variant="overline"
                                sx={{
                                    color: "primary.main",
                                    fontWeight: 700,
                                    letterSpacing: 1.5,
                                    fontSize: "0.85rem",
                                }}
                            >
                                QUEM SOMOS
                            </Typography>
                            <Typography
                                variant="h4"
                                sx={{
                                    fontWeight: 700,
                                    mt: 1,
                                    mb: 3,
                                    color: "text.primary",
                                }}
                            >
                                Nossa essência e paixão pelo que fazemos
                            </Typography>

                            <Stack spacing={2}>
                                <Typography variant="body1" color="var(--cinza)" sx={{ lineHeight: 1.8 }}>
                                    Nossa loja nasceu com o objetivo de oferecer produtos de alta
                                    qualidade, aliados a uma experiência de compra simples,
                                    transparente e segura. Acreditamos que cada detalhe importa — do
                                    atendimento à entrega.
                                </Typography>

                                <Typography variant="body1" color="var(--cinza)" sx={{ lineHeight: 1.8 }}>
                                    Trabalhamos diariamente para selecionar os melhores produtos,
                                    prezando pela procedência, confiabilidade e inovação. Nosso foco
                                    está em construir uma relação de confiança duradoura com cada
                                    cliente.
                                </Typography>

                                <Typography variant="body1" color="var(--cinza)" sx={{ lineHeight: 1.8 }}>
                                    Mais do que vender, buscamos entregar valor, praticidade e uma
                                    experiência positiva em cada interação com a nossa marca.
                                </Typography>
                            </Stack>
                        </Box>
                    </Grid>
                </Grid>
            </Container>

            {/* --- SEÇÃO DE VALORES (CARDS) --- */}
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: 4,
                    p: 4,
                    bgcolor: "#f9f9f9"
                }}
            >
                {cardsData.map((item, index) => (
                    <Paper
                        key={index}
                        elevation={0}
                        sx={{

                            width: 300,
                            height: 320,

                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",

                            p: 3,
                            borderRadius: 4,
                            border: "1px solid",
                            borderColor: "grey.200",
                            bgcolor: "white",
                            transition: "all 0.3s ease",

                            "&:hover": {
                                transform: "translateY(-8px)",
                                boxShadow: "0 12px 40px rgba(0,0,0,0.1)",
                                borderColor: "primary.main",
                            },
                        }}
                    >
                        <Avatar
                            sx={{
                                bgcolor: "var(--azul)",
                                color: "var(--branco)",
                                width: 64,
                                height: 64,
                                mb: 2,
                            }}
                        >
                            {item.icon}
                        </Avatar>

                        <Typography variant="h6" fontWeight={700} gutterBottom>
                            {item.title}
                        </Typography>

                        <Typography variant="body2" color="var(--cinza)" sx={{ px: 1 }}>
                            {item.text}
                        </Typography>
                    </Paper>
                ))}
            </Box>
        </Box>
    );
}